<!-- @author Amol, @date 29-08-2021, @description added assign batch plant company popup component-->
<div class="mainContent">

  <div >
    <div>
      <label i18n="@@spmsUserReg" class="textColour" [ngStyle]="{'border-color':backgroundColorButton}">Add Sets For Migration</label>
      <span class="example-spacer"></span>
    </div>
  </div>

  <div style="margin-top: 3%;">
    <form novalidate [formGroup]="FormValid" style="width: 100%;font-size: 15px;">
      <div class="row" style="margin-top: 10px;">
        <div class="col-lg">
          <mat-form-field appearance="outline" style="width:100%">

            <mat-label i18n="Targetjointno">Set Number</mat-label>

            <input matInput type="text" formControlName="setNumber" [(ngModel)]="addsetsMigrstionData.setNumber" >
            <mat-error *ngFor="let validation of validation_messages.setNumber">
                        <span
                          *ngIf="FormValid.get('setNumber').hasError(validation.type) && (FormValid.get('setNumber').dirty || FormValid.get('setNumber').touched)">
                          {{ validation.message }}
                        </span>
            </mat-error>

          </mat-form-field>
        </div>
      </div>
      <div class="row" style="margin-top: 10px;">
        <div class="col-lg">

          <mat-form-field appearance="outline"  style="width: 100%;font-size: 15px;">
            <mat-label>Extraction type</mat-label>
            <mat-select formControlName="extractionType"  (valueChange)="onMigrationTypeChange($event)"
                        [(ngModel)]="addsetsMigrstionData.extractionType"
                        >
              <mat-option *ngFor="let obj of extractionTypeData" [value]="obj">
                {{obj.lookupvalue}}</mat-option>
            </mat-select>
                        <mat-error >
                                <span
                                  *ngIf="FormValid.get('extractionType').hasError('required')">
                                  {{'Extraction Type is required.'}}

                                </span>
                        </mat-error>
          </mat-form-field>


        </div>

    </div>
    
<!-- 
 /**
   * @Author DARSHAN NAGARAJ
   * @Date 06-02-2026
   * @Desc dropdown for selected object group name
   */ -->

<!--Object Groups row (NEW separate row OUTSIDE) -->
<div class="row" style="margin-top: 10px;">
  <div class="col-lg">

    <mat-form-field appearance="outline" style="width:100%">

      <mat-label>Object Groups</mat-label>

      <mat-select  formControlName="selectedObjectGroup">

        <mat-option *ngFor="let group of objectGroupOptions" [value]="group">
          {{ group }}
        </mat-option>

      </mat-select>
      
      <mat-error
        *ngIf="FormValid.get('selectedObjectGroup').hasError('required') &&
               (FormValid.get('selectedObjectGroup').touched ||
                FormValid.get('selectedObjectGroup').dirty)">
        Object Group is required.
      </mat-error>
    </mat-form-field>

  </div>
</div>


    </form>
  </div>
  <div style="height:5vh;">
    <div class="row" style= "position:sticky;left:0;bottom:0;margin-top: 2%;">

      <div class="col-lg text-center" style="margin-top: 6%;">

        <div style="text-align: end;">

           <app-common-button style="margin-top: 25px; "label="Save" title="Save"
                            [buttonId]="116" [critical]="true" width="110px"(clicked)="saveData()">
                         </app-common-button>
        
        <app-common-button
      label="Cancel" title="Cancel" [critical]="true" [buttonId]="1111" variant="cancel" width="110px" (clicked)="close()"
      style="margin-left: 6px; margin-right: 6px">
    </app-common-button>
       
        </div>
      </div>
    </div>
  </div>
</div>

